import { ModelData } from '@hh.ru/magritte-ui';
import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

export type AreaTree = ModelData[];

export default autoGeneratedReducer<AreaTree>([]);
